<template>
  <div>
    <el-form :inline="true" class="me-form" size="small" :model="dataList">
      <div class="me-form-left">
        <el-form-item label="日期选择">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            v-model="formData.date"
          >
          </el-date-picker>
        </el-form-item>
        <span style="margin-left: 300px">
          <el-button type="primary" size="small" @click="getLogData">获取</el-button>
          <el-button type="primary" size="small" @click="getList">刷新</el-button>
        </span>
      </div>
    </el-form>
    <el-table :data="dataList">
      <el-table-column label="下载时间" prop="date">
        <div slot-scope="scope">
          {{ scope.row.date | time }}
        </div>
      </el-table-column>
      <el-table-column label="文件位置" prop="log_url" width="200px">
        <div slot-scope="scope">
          <el-button type="text">
              {{ scope.row.log_url }}
            </el-button>
          <!-- <a :href="scope.row.log_url" target="_blank">
            <el-button type="text">
              {{ scope.row.log_url }}
            </el-button>
          </a> -->
        </div>
      </el-table-column>
      <el-table-column label="文件名称" prop="name"></el-table-column>
      <el-table-column label="操作" prop="">
       <div slot-scope="scope">
          <el-button type="text" size="small" @click="goDown(scope.row)">下载</el-button>
       </div>
      </el-table-column>
    </el-table>
    <div class="me-pagination">
      <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pagination.page_index"
      :page-sizes="[10]"
      :page-size="pagination.count"
      layout="total, sizes, prev, pager, next"
      :total="pagination.total_count">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import apis from "@/config/apis";
import { loadList } from "@/plugins/util"
export default {
  data() {
    return {
      search:{
        page_index:1,
        hard_number:this.hard_number
      },
      dataList:[],
      pagination:{},
      formData:{
        log_type:'正常日志'
      }
    };
  },
  props: {
    hard_number: {
      type: String,
    },
  },
  methods: {
     getLogData() {
      if(this.formData.date){
        this.$axios
          .get(apis.terminal_android_log, {
            params: {
              hard_number: this.hard_number,
              date: this.formData.date,
              log_type: this.formData.log_type
            }
          }).then(()=>{
             this.$message.success('正在获取日志')
          })
      }else{
         this.$message.error('请选择日期')
      }
    },
    getList() {
      this.$axios.get(apis.terminal_android_log, {
        params:this.search
      }).then((res) => {
        console.log(res);
        this.dataList = res.data.data
        this.pagination = res.data.pagination
        console.log(this.dataList);
      });
    },
    handleCurrentChange(page_index) {
      this.search.page_index = page_index
      this.getList()
    },
    // 下载
    goDown(item) {
      console.log(item);
      let fileName = item.name
      let cabinetUrl = item.log_url
      loadList(cabinetUrl,fileName)
    }
  },
};

</script>

<style></style>
